module.exports = __webpack_public_path__ + "static/HAN-logo-09-c62a3754810596184b8799ca29e23baa.svg";